exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sn-filename {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n}\r\n\r\n.sn-filename:hover {\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/list/attachment-list/attachment-list.component.css
// module id = ../../../../../src/app/components/list/attachment-list/attachment-list.component.css
// module chunks = main